import React, { useState, useEffect, useRef } from 'react'; // <-- ДОБАВЛЕНО: useEffect и useRef
import { Button, Container, Nav, Navbar } from "react-bootstrap";
import { observer } from "mobx-react-lite";
import { Link, useLocation } from "react-router-dom";
import { menuItems } from "./helpers/menuItems";
import FormSelection from "./modals/FormSelection";

const NavBar = observer(() => {
    const [formSelectionVisible, setFormSelectionVisible] = useState(false);
    const [expanded, setExpanded] = useState(false);

    const location = useLocation();

    // ДОБАВЛЕНО: Создаем реф для контейнера меню
    const menuRef = useRef(null); // <-- ДОБАВЛЕНО

    const windowWidth = useRef(window.innerWidth)

    // Функция для закрытия меню
    const handleCloseMenu = () => {
        setExpanded(false);
    };

    // ДОБАВЛЕНО: Эффект для обработки клика вне меню
    useEffect(() => {
        // Функция, которая проверяет, был ли клик вне меню
        const handleClickOutside = (event) => {
            // Если меню открыто И клик был вне элемента, на который ссылается menuRef
            if (expanded && menuRef.current && !menuRef.current.contains(event.target)) {
                handleCloseMenu(); // Закрываем меню
            }
        };

        // Если меню открыто, добавляем слушатель клика на весь документ
        if (expanded) {
            document.addEventListener('click', handleClickOutside);
        }

        // Cleanup-функция: удаляем слушатель события, когда меню закрывается или компонент размонтируется
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [expanded]); // <-- Эффект повторно запускается только при изменении состояния expanded

    return (
        <>
            <Navbar expanded={expanded} onToggle={(isExpanded) => setExpanded(isExpanded)} expand="lg" className="my-navbar" ref={menuRef}> {/* <-- ИЗМЕНЕНО (добавлен ref={menuRef}) */}
                <Container>
                    <Link to="/" className="navbar-brand-qwe" onClick={handleCloseMenu}>
                        Санаторий<br /> {/* <-- Добавлен текст "Санаторий" и перенос строки */}
                        <span>Родник</span> {/* <-- "Родник" обернут в span */}
                    </Link>
                    {windowWidth.current < 991 ?
                        <Button
                            className="mr-1"
                            variant="success"
                            onClick={() => {
                                handleCloseMenu();
                                setFormSelectionVisible(true);
                            }}
                        >
                            Забронировать
                        </Button>
                        :
                        <></>
                    }
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="my-navbar-nav-container">
                            {/* Контейнер для меню и кнопки */}
                            <div className="navbar-menu-and-button">
                                <ul className="menu">
                                    {menuItems.map((item, index) => (
                                        <li
                                            key={index}
                                            className="menu-item mobile-visible"
                                        >
                                            <Link
                                                to={item.link || "#"}
                                                className={`nav-link ${location.pathname === item.link ? 'active' : ''}`}
                                                onClick={handleCloseMenu}
                                            >
                                                {item.title}
                                            </Link>

                                            {/* Подменю (1 уровень) */}
                                            {item.submenu && (
                                                <ul className="submenu">
                                                    {item.submenu.map((subItem, subIndex) => (
                                                        <li
                                                            key={subIndex}
                                                        >
                                                            <Link
                                                                to={subItem.link}
                                                                className={`submenu-link ${location.pathname === subItem.link ? 'active' : ''}`}
                                                                onClick={handleCloseMenu}
                                                            >
                                                                {subItem.title}
                                                            </Link>
                                                            {subItem.submenu && (
                                                                <ul className="submenu2">
                                                                    {subItem.submenu.map((nestedItem, nestedIndex) => (
                                                                        <li key={nestedIndex}>
                                                                            <Link
                                                                                to={nestedItem.link}
                                                                                className={`submenu2-link ${location.pathname === nestedItem.link ? 'active' : ''}`}
                                                                                onClick={handleCloseMenu}
                                                                            >
                                                                                {nestedItem.title}
                                                                            </Link>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            )}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                                {/* Кнопка "Забронировать" */}
                                <Button
                                    variant="success"
                                    onClick={() => {
                                        handleCloseMenu();
                                        setFormSelectionVisible(true);
                                    }}
                                >
                                    Забронировать
                                </Button>
                            </div>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <FormSelection show={formSelectionVisible} onHide={() => setFormSelectionVisible(false)}/>
        </>
    );
});

export default NavBar;